module.exports = __webpack_public_path__ + "static/file/Sample_Parent_Email_Color.15d1c12.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/Sample_Parent_Email_Color.docx
// module id = 3UTL
// module chunks = 18